import script from "./AlgorithmRealtimeDataPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./AlgorithmRealtimeDataPanel.vue?vue&type=script&setup=true&lang=js"

import "./AlgorithmRealtimeDataPanel.vue?vue&type=style&index=0&id=d084871a&lang=less&scoped=true"

import exportComponent from "E:\\上蔡\\大数据\\宽版\\shancgai2-修改农业-审计修改\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d084871a"]])

export default __exports__